export const MessageList = ({ messages }) => {
  if (messages.length === 0) return <p className="text-sm text-muted" data-testid="messages-empty">Nessun messaggio ricevuto.</p>;
  return (
    <ul className="space-y-3" data-testid="messages-list">
      {messages.map((m) => (
        <li key={m.id} className="rounded-2xl border border-border bg-white p-4 text-sm" data-testid={`message-row-${m.id}`}>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mb-2">
            <span className="text-ink font-medium">{m.name}</span>
            <a href={`mailto:${m.email}`} className="text-muted hover:text-pine">{m.email}</a>
            {m.phone && <span className="text-muted">{m.phone}</span>}
            <span className="text-[11px] font-mono uppercase tracking-wider text-sage">{m.service}{m.mode ? ` · ${m.mode}` : ""}</span>
            <span className="ml-auto font-mono text-xs text-muted">{m.created_at?.slice(0, 16).replace("T", " ")}</span>
          </div>
          <p className="text-ink/80 whitespace-pre-line leading-relaxed">{m.message}</p>
        </li>
      ))}
    </ul>
  );
};
